import React from "react"
import PropTypes from "prop-types"
import { MyMazdaWrapper } from "containers"
import { MyMazdaChangeEmail } from "AtomicContainers"

const MyMazdaConfirmChangeEmailBlock = props => (
  <MyMazdaWrapper breadcrumb={["MyMazda", "Confirm Change of Email"]}>
    <MyMazdaChangeEmail {...props} />
  </MyMazdaWrapper>
)

MyMazdaConfirmChangeEmailBlock.propTypes = {
  buttonText: PropTypes.string,
  successHeading: PropTypes.string,
  changeEmailEndpoint: PropTypes.string,
  continueButtonText: PropTypes.string,
  changeEmailSuccessMessage: PropTypes.string,
  submitInstructionsText: PropTypes.string
}

MyMazdaConfirmChangeEmailBlock.defaultProps = {
  buttonText: "Login",
  successHeading: "New Email Confirmed",
  changeEmailEndpoint: "/api/mymazda/ChangeEmail",
  continueButtonText: "Continue to MyMazda",
  changeEmailSuccessMessage: "We've updated your email address. Click below to continue to MyMazda.",
  submitInstructionsText: "<p>Login with your password to confirm your updated email address: <strong>$newEmail$</strong></p>"
}

export default MyMazdaConfirmChangeEmailBlock



// WEBPACK FOOTER //
// ./src/blocks/mymazda/confirm-change-email/index.jsx